import React from "react";

export default function FileIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_232_1296"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_232_1296)">
        <path
          d="M7.50065 14.9998H12.5007C12.7368 14.9998 12.9347 14.92 13.0944 14.7603C13.2541 14.6005 13.334 14.4026 13.334 14.1665C13.334 13.9304 13.2541 13.7325 13.0944 13.5728C12.9347 13.413 12.7368 13.3332 12.5007 13.3332H7.50065C7.26454 13.3332 7.06662 13.413 6.9069 13.5728C6.74718 13.7325 6.66732 13.9304 6.66732 14.1665C6.66732 14.4026 6.74718 14.6005 6.9069 14.7603C7.06662 14.92 7.26454 14.9998 7.50065 14.9998ZM7.50065 11.6665H12.5007C12.7368 11.6665 12.9347 11.5866 13.0944 11.4269C13.2541 11.2672 13.334 11.0693 13.334 10.8332C13.334 10.5971 13.2541 10.3991 13.0944 10.2394C12.9347 10.0797 12.7368 9.99984 12.5007 9.99984H7.50065C7.26454 9.99984 7.06662 10.0797 6.9069 10.2394C6.74718 10.3991 6.66732 10.5971 6.66732 10.8332C6.66732 11.0693 6.74718 11.2672 6.9069 11.4269C7.06662 11.5866 7.26454 11.6665 7.50065 11.6665ZM5.00065 18.3332C4.54232 18.3332 4.14996 18.17 3.82357 17.8436C3.49718 17.5172 3.33398 17.1248 3.33398 16.6665V3.33317C3.33398 2.87484 3.49718 2.48248 3.82357 2.15609C4.14996 1.8297 4.54232 1.6665 5.00065 1.6665H10.9798C11.202 1.6665 11.4138 1.70817 11.6152 1.7915C11.8166 1.87484 11.9937 1.99289 12.1465 2.14567L16.1882 6.18734C16.3409 6.34012 16.459 6.5172 16.5423 6.71859C16.6257 6.91998 16.6673 7.13178 16.6673 7.354V16.6665C16.6673 17.1248 16.5041 17.5172 16.1777 17.8436C15.8513 18.17 15.459 18.3332 15.0007 18.3332H5.00065ZM10.834 6.6665V3.33317H5.00065V16.6665H15.0007V7.49984H11.6673C11.4312 7.49984 11.2333 7.41998 11.0736 7.26025C10.9138 7.10053 10.834 6.90262 10.834 6.6665Z"
          fill="#505050"
        />
      </g>
    </svg>
  );
}
